import {
  getRoles as getRolePermissionsService,
  createRole as assignRolePermissionsService,
} from "services/admin/roleManagement/roleAccess/roleAccessService";
import {
  getRolePermissionsStart,
  getRolePermissionsSuccess,
  getRolePermissionsFailure,
  assignRolePermissionsStart,
  assignRolePermissionsSuccess,
  assignRolePermissionsFailure,
} from "./roleAccessSlice";
import { showSuccessToast, showErrorToast } from "utils/toastNotification";

// Fetch all role permissions
export const fetchRolePermissions = () => async (dispatch) => {
  try {
    dispatch(getRolePermissionsStart());
    const response = await getRolePermissionsService();

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(getRolePermissionsSuccess(response.data));
      return { success: true, data: response.data };
    } else {
      const errorMsg =
        response?.meta?.message || "Failed to fetch role permissions";
      dispatch(getRolePermissionsFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Fetch role permissions error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to fetch role permissions";
    dispatch(getRolePermissionsFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};

// Assign permissions to a role
export const assignRolePermissions =
  (rolePermissionData) => async (dispatch) => {
    try {
      dispatch(assignRolePermissionsStart());
      const response = await assignRolePermissionsService(rolePermissionData);

      if (response?.meta?.status === true && response?.meta?.code === 200) {
        dispatch(assignRolePermissionsSuccess(response.data));
        showSuccessToast(
          response?.meta?.message || "Permissions assigned successfully!",
        );
        return { success: true, data: response.data };
      } else {
        const errorMsg =
          response?.meta?.message || "Failed to assign permissions";
        dispatch(assignRolePermissionsFailure(errorMsg));
        showErrorToast(errorMsg);
        return { success: false, error: errorMsg };
      }
    } catch (error) {
      console.error("Assign permissions error:", error);
      const errorMsg =
        error?.response?.data?.meta?.message ||
        error.message ||
        "Failed to assign permissions";
      dispatch(assignRolePermissionsFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  };
